export const AMAAS_API_URL = window.env.AMAAS_API_URL;
export const SENTRY_DSN = window.env.SENTRY_DSN;
export const SENTRY_ENVIRONMENT = window.env.SENTRY_ENVIRONMENT;
export const GOOGLE_MAPS_API_KEY = window.env.GOOGLE_MAPS_API_KEY;
export const ZITADEL_API_URL = window.env.ZITADEL_API_URL;
export const LANDING_URL = window.env.LANDING_URL;
export const IS_PROD_ENVIRONMENT = SENTRY_ENVIRONMENT.includes('prod') || SENTRY_ENVIRONMENT.includes('rc');
